import React from "react";

const CarrierInfo = (props) => {
  const producerCode = props.producerCode ? (
    <span className="carrier-addinfo">
      Producer Code: <span className="number">{props.producerCode}</span>
    </span>
  ) : null;

  return (
    <div className="carrier-label">
      <div className="carrier-logo">
        <img src={props.carrierLogo} alt="" />
      </div>

      <div className="carrier-info">
        <span className="carrier-name">{props.carrierName}</span>
        <span className="carrier-brand">{props.carrierBrand}</span>
        {producerCode}
        <div className="carrier-contact">
          <span className="carrier-addinfo">
            Direct Service Number:{" "}
            <span className="number">{props.carrierPhone}</span>
          </span>
          <br />
          {props.hasAddPhone && (
            <span className="carrier-addinfo">
              {props.addPhoneType}:{" "}
              <span className="number">{props.addPhone}</span>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default CarrierInfo;
